import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

/** 300 slots in a tighter grid so the tally sheet + footer fit one A4 page with the letterhead. */
const COLS_PER_ROW = 25;
const TOTAL_SLOTS = 300;

const styles = StyleSheet.create({
  grid: {
    width: '100%',
  },
  row: {
    flexDirection: 'row',
    width: '100%',
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    minHeight: 11,
    alignItems: 'center',
  },
  firstRow: {
    borderTopWidth: 1,
  },
  cell: {
    width: `${100 / COLS_PER_ROW}%`,
    borderRightWidth: 1,
    borderRightColor: '#000',
    justifyContent: 'center',
    paddingVertical: 1,
  },
  cellText: {
    fontSize: 5.5,
    textAlign: 'center',
    lineHeight: 1,
  },
});

const TellySheetTable = () => {
  const rows = [];
  const numRows = TOTAL_SLOTS / COLS_PER_ROW;

  for (let r = 0; r < numRows; r++) {
    const cells = [];
    const start = r * COLS_PER_ROW + 1;
    const end = start + COLS_PER_ROW - 1;
    for (let i = start; i <= end; i++) {
      cells.push(
        <View style={styles.cell} key={i}>
          <Text style={styles.cellText}>{i}</Text>
        </View>,
      );
    }
    rows.push(
      <View
        key={r}
        style={[styles.row, r === 0 ? styles.firstRow : {}]}
        wrap={false}
      >
        {cells}
      </View>,
    );
  }

  return <View style={styles.grid}>{rows}</View>;
};

export default TellySheetTable;
